import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import deLocale from "i18n-iso-countries/langs/de.json";
import plLocale from "i18n-iso-countries/langs/pl.json";

countries.registerLocale(enLocale);
countries.registerLocale(deLocale);
countries.registerLocale(plLocale);

const countryOptions = getCountries().map((countryCode) => ({
    code: countryCode,
    name: {
        en: countries.getName(countryCode, "en", {select: 'official'}),
        de: countries.getName(countryCode, "de", {select: 'official'}),
        pl: countries.getName(countryCode, "pl", {select: 'official'}),
    },
    callingCode: `+${getCountryCallingCode(countryCode)}`,
})).filter((country) => !!country.name.en);

const countryCodeName = countryOptions.map((country) => ({
    code: country.code,
    name: country.name,
}))

const countryCodeCallingCode = Array.from(
    new Map(
        countryOptions.map((country) => [
            country.callingCode,
            {
                code: country.code,
                phoneCode: country.callingCode,
            }
        ])
    ).values()
).sort((a, b) => {
    const codeA = parseInt(a.phoneCode.replace('+', ''), 10);
    const codeB = parseInt(b.phoneCode.replace('+', ''), 10);
    return codeA - codeB;
});

export { countryCodeName, countryCodeCallingCode };